/* storefront-hero-video:start */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var small = window.matchMedia('(max-width: 680px)');
  document.querySelectorAll('[data-light-hero-video]').forEach(function (video) {
    var hero = video.closest('[data-storefront-hero]');
    var control = hero && hero.querySelector('[data-hero-video-toggle]');
    var userPaused = false;
    function allowed() {
      var saveData = navigator.connection && navigator.connection.saveData;
      return !reduced.matches && !saveData && (!small.matches || video.getAttribute('data-mobile-video') === 'true');
    }
    function updateControl() {
      if (!control) return;
      control.hidden = !allowed();
      control.setAttribute('aria-pressed', String(video.paused));
      control.textContent = video.paused ? '背景動画を再生' : '背景動画を一時停止';
    }
    function syncVideo() {
      video.removeAttribute('autoplay');
      if (!allowed()) {
        video.pause();
        video.style.display = 'none';
        updateControl();
        return;
      }
      video.style.display = 'block';
      video.muted = true;
      if (userPaused) { video.pause(); updateControl(); return; }
      var attempt = video.play();
      if (attempt && typeof attempt.then === 'function') {
        attempt.then(function () {
          if (!allowed() || userPaused) video.pause();
          if (!allowed()) video.style.display = 'none';
          updateControl();
        }).catch(function () {
          video.style.display = 'none';
          if (control) control.hidden = true;
        });
      }
      updateControl();
    }
    if (control) control.addEventListener('click', function () { userPaused = !video.paused; syncVideo(); });
    video.addEventListener('play', updateControl);
    video.addEventListener('pause', updateControl);
    [reduced, small].forEach(function (query) {
      if (query.addEventListener) query.addEventListener('change', syncVideo);
      else query.addListener(syncVideo);
    });
    syncVideo();
  });
}());
/* storefront-hero-video:end */

/* ─── Brand Story: scroll-triggered autoplay ─── */
(function () {
  if (!("IntersectionObserver" in window)) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  /* ── Native HTML5 video ── */
  document.querySelectorAll("[data-brand-story-video]").forEach(function (video) {
    video.muted = true;
    video.setAttribute("playsinline", "");

    var played = false;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !played) {
          played = true;
          var p = video.play();
          if (p && typeof p.catch === "function") p.catch(function () {});
          obs.unobserve(video);
        }
      });
    }, { rootMargin: "0px 0px -80px 0px", threshold: 0.25 });

    obs.observe(video);
  });

  /* ── YouTube iframe via Official IFrame API (確実な自動再生) ── */
  var ytTargets = document.querySelectorAll("[data-brand-story-yt][data-yt-id]");
  if (ytTargets.length > 0) {
    /* YouTube IFrame APIを動的読み込み */
    if (!window.YT) {
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.head.appendChild(tag);
    }

    window.__brandStoryPlayers = window.__brandStoryPlayers || [];

    function initBrandStoryPlayer(wrapper) {
      var playerEl = wrapper.querySelector("[id^='bs-yt-player-']");
      if (!playerEl) return;
      var videoId = wrapper.getAttribute("data-yt-id");

      var player = new YT.Player(playerEl.id, {
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          mute: 1,
          playsinline: 1,
          controls: 1,
          modestbranding: 1,
          rel: 0
        },
        events: {
          onReady: function (e) {
            var played = false;
            var obs = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting && !played) {
                  played = true;
                  try {
                    e.target.mute();
                    e.target.seekTo(0);
                    e.target.playVideo();
                  } catch (err) {}
                  obs.unobserve(wrapper);
                }
              });
            }, { rootMargin: "0px 0px -80px 0px", threshold: 0.25 });
            obs.observe(wrapper);
          }
        }
      });
      window.__brandStoryPlayers.push(player);
    }

    window.onYouTubeIframeAPIReady = function () {
      ytTargets.forEach(initBrandStoryPlayer);
    };
    /* 既にAPIロード済みの場合（複数セクション読み込み時） */
    if (window.YT && window.YT.Player) {
      ytTargets.forEach(initBrandStoryPlayer);
    }
  }
})();

/* storefront-shell:start */
(function () {
  'use strict';
  /* storefront-inline-dock:start */
  function createInlineDockPolicy(options) {
    var win = options.window;
    var doc = options.document;
    var records = [];
    var stopped = false;
    var supported = typeof win.IntersectionObserver === 'function';
    var scopeSelector = '[data-cro-product], [data-quote-product-detail]';
    var productDockSelector = '[data-product-mobile-dock], [data-quote-mobile-dock]';

    function visibleTarget(target) {
      if (target.hidden || !target.getClientRects().length) return false;
      var rect = target.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) return false;
      var style = win.getComputedStyle(target);
      return style.display !== 'none' && style.visibility === 'visible';
    }
    function disconnect(record) {
      record.generation++;
      if (record.observer) record.observer.disconnect();
      record.observer = null;
    }
    function refresh() {
      if (!supported || stopped) return;
      var mobile = win.matchMedia('(max-width: 767px)').matches;
      var headerHeight = options.header ? Math.max(0, Math.ceil(options.header.getBoundingClientRect().height || 0)) : 0;
      records.forEach(function (record) {
        if (!mobile || !record.targets.length) {
          disconnect(record);
          record.active = false;
          if (record.inlineVisible) { record.inlineVisible = false; options.onChange(); }
          return;
        }
        var height = Math.ceil(record.dock.getBoundingClientRect().height || 0);
        // Reserve the same occluded area even while the dock is suspended.
        // This is deliberately independent from the shell's visible-dock offset.
        if (height > 0) record.dockHeight = height;
        var margin = '-' + (headerHeight + 8) + 'px 0px -' + (record.dockHeight + 8) + 'px 0px';
        record.active = true;
        if (record.observer && record.margin === margin) return;
        disconnect(record);
        record.margin = margin;
        record.states = new Map(record.targets.map(function (target) { return [target, null]; }));
        var generation = record.generation;
        record.observer = new win.IntersectionObserver(function (entries) {
          if (stopped || !record.active || generation !== record.generation) return;
          // Observer callbacks contain changed targets, not a complete snapshot.
          entries.forEach(function (entry) {
            if (!record.states.has(entry.target)) return;
            // Edge contact can intersect at ratio 0, then become partial without
            // crossing a [0, 1] threshold. Only non-intersection proves outside.
            var state = !visibleTarget(entry.target) || !entry.isIntersecting ? 0 : entry.intersectionRatio >= 1 ? 1 : .5;
            record.states.set(entry.target, state);
          });
          var states = record.targets.map(function (target) { return visibleTarget(target) ? record.states.get(target) : 0; });
          var next = record.inlineVisible;
          if (states.some(function (state) { return state === 1; })) next = true;
          else if (states.every(function (state) { return state === 0; })) next = false;
          if (next !== record.inlineVisible) { record.inlineVisible = next; options.onChange(); }
        }, { rootMargin: margin, threshold: [0, 1] });
        record.targets.forEach(function (target) { record.observer.observe(target); });
      });
    }
    if (supported) doc.querySelectorAll(productDockSelector).forEach(function (dock) {
      var scope = dock.closest(scopeSelector);
      if (!scope) return;
      var targets = Array.from(scope.querySelectorAll('[data-storefront-inline-action]')).filter(function (target) {
        return target.closest(scopeSelector) === scope && !target.closest(productDockSelector);
      });
      records.push({ dock: dock, targets: targets, states: new Map(), dockHeight: 156, inlineVisible: false, active: false, observer: null, margin: '', generation: 0 });
    });
    refresh();
    return {
      refresh: refresh,
      shouldSuspend: function (dock) {
        var record = records.find(function (item) { return item.dock === dock; });
        return !!(!stopped && record && record.active && record.inlineVisible && !dock.contains(doc.activeElement));
      },
      destroy: function () { stopped = true; records.forEach(disconnect); }
    };
  }
  /* storefront-inline-dock:end */
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  var overlay = document.querySelector('[data-mobile-menu-overlay]');
  var header = document.querySelector('[data-storefront-header]');
  var genericDock = document.querySelector('.mobile-cta-bar');
  var close = menu && menu.querySelector('[data-mobile-menu-close]');
  var dockSelector = '.mobile-cta-bar, [data-product-mobile-dock], [data-quote-mobile-dock], .cart-mobile-checkout, .bulk-quote-summary';
  var desktop = window.matchMedia('(min-width: 1280px)');
  var dockStates = new Map();
  var backgroundStates = new Map();
  var open = false;
  var returnFocus = null;
  var layoutHeight = window.innerHeight;
  var inlineDockPolicy = null;

  function editableFocus() {
    var active = document.activeElement;
    return !!(active && active.closest && active.closest('input:not([type="hidden"]), textarea, select, [contenteditable="true"]'));
  }
  function measureFixedDocks() {
    var offset = 0;
    document.querySelectorAll(dockSelector).forEach(function (dock) {
      if (dock.hidden || !dock.getClientRects().length) return;
      var style = window.getComputedStyle(dock);
      if (style.position !== 'fixed' || style.display === 'none' || style.visibility !== 'visible') return;
      var height = dock.getBoundingClientRect().height;
      if (height <= 0) return;
      var bottom = Math.max(0, parseFloat(style.bottom) || 0);
      offset = Math.max(offset, Math.ceil(height + bottom));
    });
    document.documentElement.style.setProperty('--storefront-fixed-dock-offset', offset + 'px');
  }
  function syncDocks() {
    var viewport = window.visualViewport;
    var keyboard = editableFocus() || !!(viewport && viewport.scale === 1 && layoutHeight - viewport.height > 150);
    document.documentElement.toggleAttribute('data-keyboard-open', keyboard);
    document.querySelectorAll(dockSelector).forEach(function (dock) {
      var suspend = open || keyboard || !!(inlineDockPolicy && inlineDockPolicy.shouldSuspend(dock));
      if (suspend && !dockStates.has(dock)) {
        dockStates.set(dock, { inert: dock.inert, ariaHidden: dock.getAttribute('aria-hidden') });
        dock.inert = true;
        dock.setAttribute('aria-hidden', 'true');
        dock.classList.add('storefront-dock-suspended');
      } else if (!suspend && dockStates.has(dock)) {
        var previous = dockStates.get(dock);
        dock.inert = previous.inert;
        if (previous.ariaHidden === null) dock.removeAttribute('aria-hidden');
        else dock.setAttribute('aria-hidden', previous.ariaHidden);
        dock.classList.remove('storefront-dock-suspended');
        dockStates.delete(dock);
      }
    });
    measureFixedDocks();
  }
  function isolateBackground() {
    var branch = menu;
    while (branch && branch.parentElement) {
      var parent = branch.parentElement;
      Array.from(parent.children).forEach(function (sibling) {
        if (sibling === branch || sibling === overlay || sibling.matches(dockSelector)) return;
        if (!backgroundStates.has(sibling)) {
          backgroundStates.set(sibling, sibling.inert);
          sibling.inert = true;
        }
      });
      if (parent === document.body) break;
      branch = parent;
    }
  }
  function restoreBackground() {
    backgroundStates.forEach(function (wasInert, element) { element.inert = wasInert; });
    backgroundStates.clear();
  }
  function focusables() {
    return Array.from(menu.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
      return !element.hidden && !element.closest('[hidden], [inert]') && element.getClientRects().length > 0;
    });
  }
  function openMenu() {
    if (!toggle || !menu || open || desktop.matches) return;
    returnFocus = document.activeElement;
    open = true;
    menu.hidden = false;
    menu.inert = false;
    menu.setAttribute('aria-modal', 'true');
    menu.classList.add('is-open');
    if (overlay) { overlay.hidden = false; overlay.classList.add('is-open'); }
    document.body.classList.add('menu-open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'メニューを閉じる');
    syncDocks();
    isolateBackground();
    (close || focusables()[0] || menu).focus();
  }
  function closeMenu(restoreFocus) {
    if (!open) return;
    open = false;
    menu.classList.remove('is-open');
    menu.removeAttribute('aria-modal');
    menu.inert = true;
    menu.hidden = true;
    if (overlay) { overlay.classList.remove('is-open'); overlay.hidden = true; }
    document.body.classList.remove('menu-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'メニューを開く');
    restoreBackground();
    if (restoreFocus && !desktop.matches) {
      var target = returnFocus && returnFocus.isConnected ? returnFocus : toggle;
      target.focus();
    }
    returnFocus = null;
    syncDocks();
  }
  if (toggle && menu) {
    toggle.hidden = false;
    menu.hidden = true;
    menu.inert = true;
    toggle.addEventListener('click', function () { if (open) closeMenu(true); else openMenu(); });
    if (close) close.addEventListener('click', function () { closeMenu(true); });
    if (overlay) overlay.addEventListener('click', function () { closeMenu(true); });
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a[href]')) closeMenu(false);
    });
    document.addEventListener('keydown', function (event) {
      if (!open) return;
      if (event.key === 'Escape') { event.preventDefault(); closeMenu(true); return; }
      if (event.key !== 'Tab') return;
      var elements = focusables();
      var first = elements[0];
      var last = elements[elements.length - 1];
      if (!first) { event.preventDefault(); menu.focus(); return; }
      if (event.shiftKey && (document.activeElement === first || !menu.contains(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !menu.contains(document.activeElement))) {
        event.preventDefault(); first.focus();
      }
    });
    var onDesktopChange = function () { if (desktop.matches) closeMenu(false); };
    if (desktop.addEventListener) desktop.addEventListener('change', onDesktopChange);
    else desktop.addListener(onDesktopChange);
  }
  function measureHeader() {
    if (header) document.documentElement.style.setProperty('--storefront-header-height', Math.ceil(header.getBoundingClientRect().height) + 'px');
    var visibleDock = !!(genericDock && genericDock.getClientRects().length);
    document.documentElement.toggleAttribute('data-generic-dock-present', visibleDock);
    if (visibleDock) document.documentElement.style.setProperty('--storefront-generic-dock-height', Math.ceil(genericDock.getBoundingClientRect().height) + 'px');
    measureFixedDocks();
  }
  document.addEventListener('focusin', syncDocks);
  document.addEventListener('focusout', function () { window.requestAnimationFrame(syncDocks); });
  window.addEventListener('resize', function () {
    if (!editableFocus()) layoutHeight = window.innerHeight;
    measureHeader();
    if (inlineDockPolicy) inlineDockPolicy.refresh();
    syncDocks();
  });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncDocks);
    window.visualViewport.addEventListener('scroll', syncDocks);
  }
  if ('ResizeObserver' in window) {
    var sizeObserver = new ResizeObserver(function () {
      measureHeader();
      if (inlineDockPolicy) inlineDockPolicy.refresh();
      syncDocks();
    });
    if (header) sizeObserver.observe(header);
    document.querySelectorAll(dockSelector).forEach(function (dock) { sizeObserver.observe(dock); });
  }
  inlineDockPolicy = createInlineDockPolicy({ window: window, document: document, header: header, onChange: syncDocks });
  measureHeader();
  syncDocks();
}());
/* storefront-shell:end */

/* ─── UX batch2: バリエーション価格同期 / 二重送信防止 / honeypot ─── */
(function () {
  /* 商品ページ：バリエーション選択で価格表示を同期（option の data-price を反映） */
  var vsel = document.querySelector(".product-page select[name='id']");
  var priceEl = document.querySelector(".product-page .product-buy .price");
  if (vsel && priceEl) {
    vsel.addEventListener("change", function () {
      var opt = vsel.options[vsel.selectedIndex];
      var p = opt && opt.getAttribute("data-price");
      if (p) priceEl.textContent = p;
    });
  }

  /* お問い合わせフォーム：honeypot（ボット除外）＋ 二重送信防止 */
  document.querySelectorAll("form").forEach(function (form) {
    var ft = form.querySelector("input[name='form_type']");
    if (!ft || ft.value !== "contact") return;
    form.addEventListener("submit", function (e) {
      /* honeypot：非表示の囮欄に値 → ボットとみなし送信中止 */
      var hp = form.querySelector("input[name='contact[website_url]']");
      if (hp && hp.value.trim() !== "") { e.preventDefault(); return; }
      /* 送信中表示：送信処理が走った“後”に無効化（送信自体は止めない） */
      var btn = form.querySelector("button[type='submit'], input[type='submit']");
      if (btn && !btn.disabled) {
        setTimeout(function () {
          btn.disabled = true;
          btn.setAttribute("aria-busy", "true");
          if (btn.tagName === "BUTTON") { btn.dataset.origLabel = btn.textContent; btn.textContent = "送信中…"; }
        }, 0);
      }
    });
  });
})();
